import { DatasetDataInfoResponse } from "axios/apiModels";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Utils from "util/Utils";

interface SelectedDatasetsListProps {
  datasetsListWithInfo: DatasetDataInfoResponse[];
  handleUnselectAllDatasets: () => void;
  handleUnselectDataset: (identifier: String) => void;
}

const SelectedDatasetsList = ({
  datasetsListWithInfo,
  handleUnselectAllDatasets,
  handleUnselectDataset,
}: SelectedDatasetsListProps) => {
  const copyToClipboardButtonTemplate = (text: String) => {
    return (
      <Button
        icon="pi pi-clone"
        className="p-button-text ml-2 custom-button"
        onClick={() => Utils.copyToClipboard(text)}
      />
    );
  };

  const valueBodyTemplate = (rowData: DatasetDataInfoResponse) => {
    if (rowData.data.length > 0 && rowData.data[0].value !== null) {
      return (
        <div>{rowData.data[0].value.toFixed(rowData.decimalPlaces ?? 3)}</div>
      );
    }
    return <div>-</div>;
  };  

  const titleBodyTemplate = (rowData: DatasetDataInfoResponse) => {
    return (
      <div>
        {rowData.title}
        {copyToClipboardButtonTemplate(rowData.title)}
      </div>
    );
  };

  const identifierBodyTemplate = (rowData: DatasetDataInfoResponse) => {
    return (
      <div>
        {rowData.identifier}
        {copyToClipboardButtonTemplate(rowData.identifier)}
      </div>
    );
  };

  const unselectDatasetButtonTemplate = (rowData: DatasetDataInfoResponse) => {
    return (
      <Button
        icon="pi pi-times"
        className="p-button-text ml-2 custom-button"
        onClick={() => handleUnselectDataset(rowData.identifier)}
        tooltip="Unselect dataset"
        tooltipOptions={{ position: "bottom" }}
      />
    );
  };
  return (
    <div
      className="w-8 flex justify-content-center align-items-center flex-column gap-3 pt-2 pb-1 relative"
      style={{ height: "calc(100vh - 52px)" }}
    >
      {datasetsListWithInfo.length > 0 && (
        <div className="absolute top-0 left-0 m-2">
          <Button
            icon="pi pi-times"
            label="Unselect all"
            className="p-button-text unselect-all-button"
            onClick={handleUnselectAllDatasets}
          />
        </div>
      )}
      {datasetsListWithInfo.length === 0 ? (
        <div>Please select a dataset</div>
      ) : (
        <DataTable
          value={datasetsListWithInfo}
          dataKey="identifier"
          size="small"
          className="w-11"
        >
          <Column
            field="title"
            header="Title"
            style={{
              width: "55%",
            }}
            body={titleBodyTemplate}
          />
          <Column
            field="identifier"
            header="Identifier"
            style={{
              width: "30%",
            }}
            body={identifierBodyTemplate}
          />
          <Column
            field="value"
            header="Value"
            style={{
              width: "8%",
            }}
            body={valueBodyTemplate}
          />
          <Column
            field="unit"
            header="Unit"
            style={{
              width: "5%",
            }}
          />
          <Column
            body={unselectDatasetButtonTemplate}
            style={{ width: "2%" }}
          />
        </DataTable>
      )}
    </div>
  );
};

export default SelectedDatasetsList;
